interface DownArrowProps {
  width?: number;
  height?: number;
}

export const DownArrow = ({ width = 7, height = 8 }: DownArrowProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 7 8" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.43098 0.455566C3.68762 0.455566 3.89566 0.663611 3.89566 0.920246V6.30393L5.89048 4.30911C6.07195 4.12764 6.36617 4.12764 6.54764 4.30911C6.72911 4.49058 6.72911 4.7848 6.54764 4.96626L3.75956 7.75434C3.57809 7.93581 3.28387 7.93581 3.1024 7.75434L0.314324 4.96626C0.132855 4.7848 0.132855 4.49058 0.314324 4.30911C0.495793 4.12764 0.790012 4.12764 0.971481 4.30911L2.9663 6.30393V0.920246C2.9663 0.663611 3.17435 0.455566 3.43098 0.455566Z" fill="#136D38"/>
</svg>

);
